import React from 'react';
import { appPath } from '../../utils/paths';

export default function LegalDocumentLinks() {
  return <nav aria-label="Full policies" style={{display:'flex',flexWrap:'wrap',gap:'10px 16px',margin:'16px 0',fontSize:13,lineHeight:1.5}}>
    {[
      ['/privacy/', 'Privacy notice'],
      ['/terms/', 'Terms of use'],
      ['/cookies/', 'Cookies & browser storage'],
      ['/delete-data/', 'Manage my data'],
    ].map(([path,label]) => <a key={path} href={appPath(path)} target="_blank" rel="noopener noreferrer" style={{color:'inherit',textDecoration:'underline',pointerEvents:'auto',animation:'none'}}>{label}<span style={{fontSize:11}}> (new tab)</span></a>)}
  </nav>;
}
